import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Chip from '@mui/material/Chip';
import { getSingleStopSale,stopsaleDeletion,stopsaleModification } from "./stopsaleAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { useNavigate, Link,useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import 'react-phone-number-input/style.css'
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { FaEdit, FaTrash, FaPlus, FaEye, FaArrowLeft } from 'react-icons/fa';
import { getAllMainSubProduct } from "../subproduct/subproductAction";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ModifyStopSale = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { id2 } = useParams();
  const { mainid } = useParams();
  const { name1 } = useParams();
  const { name2 } = useParams();
  const ProductRef = useRef(null);
  const navigate = useNavigate();
  const [subproductdisplay, setSubproductdisplay] = useState([]);
  const [sdate, setSdate] = useState('');
  const [edate, setEdate] = useState('');
  const [remarks, setRemarks] = useState('');
  const [disbt , setDisbt ] = useState(true);
  const [subdata, setSubdata] = useState([]);
  const [productid , setProductid ] = useState('');
  const { pSDetails } = useSelector((state) => state.stopsaleList);

  console.log("pSDetails",pSDetails)

  const [stopsaleupdate, setStopsaleupdate] = useState({
    id:"",
    sdate:"",
    edate:"",
    remarks:"",
    subproductid:"",
});
console.log("dbbbxxxxxxxxxxxdf",stopsaleupdate)
const stopsalelistData = useSelector((state) => state.stopsaleList);


  
  const handleAllChange = (e) => {
    setDisbt(false);
    const name = e.target.name;
    const value = e.target.value;

    setStopsaleupdate({ ...stopsaleupdate, [name]: value });
  };

 
  const { register, reset, handleSubmit, formState: { errors } } = useForm();
  
  useEffect(() => {
    dispatch(getSingleStopSale(id));
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const initialRates = Object.keys(pSDetails).map((key) => (pSDetails[key] || '').toString());


    if(JSON.stringify(initialRates) == JSON.stringify(stopsaleupdate)){

          Swal.fire('No changes made!', '', 'warning');


    }else{
    const modifyStopsale = {
      stopsaleupdate

    }
  
  
      dispatch(
        stopsaleModification(modifyStopsale)
      )

 


      navigate(`/stopsaleList3/` + mainid + "/" + id2 + "/" + name1 + "/" + name2 );
    }







   

  }
  const onBack = () => {

    navigate(`/stopsaleList3/` + mainid + "/" + id2 + "/" + name1 + "/" + name2 );

  }

  useEffect(() => {
    if (pSDetails) {
  

      const initialRates = Object.keys(pSDetails).map((key) => (pSDetails[key] || '').toString());
      setStopsaleupdate((prevState) => ({
        ...prevState,
        id:id,
        sdate:pSDetails.start_date,
        edate:pSDetails.end_date,
        remarks:pSDetails.remarks,
        subproductid:pSDetails.subproduct_id,
      }));
    }
  }, [pSDetails, id]);

 

  return (
    <>

      <Container className="my-4 mx-4 container-xl ">

      <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
          <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify Stop Sale</h4></Card.Header>
          <Card.Body>
            <Row>
              <Col>

                <div><span className="badge bg-success" onClick={onBack} style={{ backgroundColor: 'rgb(156 186 237)', color: 'white',cursor:'pointer' }}><FaArrowLeft />&nbsp;Go Back</span></div>

                <br />

              </Col>
            </Row>
            <br />


            <Form className=" mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}



              <Row className="mb-3">

                <Form.Group as={Col} controlId="formGridMobile">
                  <Form.Label>Start Date<span className='text-danger'>*</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="sdate"
                    // min={new Date().toISOString().split('T')[0]}
                    required
                    autoComplete='off'
                    placeholder="Enter the start date"
                    value={stopsaleupdate?.sdate}
                    onChange={(e) => handleAllChange(e)}                  
                    />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridMobile">
                  <Form.Label>End Date<span className='text-danger'>*</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="edate"
                    min={sdate}
                    required
                    autoComplete='off'
                    placeholder="Enter the end date"
                    value={stopsaleupdate?.edate}
                    onChange={(e) => handleAllChange(e)}
                  />
                </Form.Group>


              </Row>


              <Form.Group as={Col} controlId="formGridProductdescription">
                <Form.Label>Remarks:</Form.Label>

                <DefaultEditor rows="5" name="remarks" style={{ backgroundColor: 'white' }} value={stopsaleupdate?.remarks} onChange={(e) => handleAllChange(e)}

                />

              </Form.Group>
              <br />
              <div class="d-grid  col-2 mx-auto" style={{ display: "flex" }}>
                <Button variant="primary" type="submit" disabled={disbt} className="btn btn-success btn-block" style={{ backgroundColor: '#1c355e' }}>
                  <FontAwesomeIcon icon={faRightToBracket} /> Save
                </Button>
              </div>

            </Form>

          </Card.Body>
        </Card>

      </Container>
    </>
  );
}

export default ModifyStopSale;